import React, { useEffect, useState } from "react";
import { Form, Col, Row, Button, Select, Input } from "antd";
import { useMediaQuery } from "react-responsive";
import "react-phone-input-2/lib/style.css";
import { PlusOutlined } from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import CurrencyInput from "react-currency-input";
const { TextArea } = Input;
const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 13,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 15,
    span: 5,
  },
};

const StockMovementAddForm = (props) => {
  const [form] = Form.useForm();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });
  const [loading, SetLoading] = useState(false);
  const [stockId, setStockId] = useState(props.stockId);

  const onFinish = (values) => {
    values["stockId"] = stockId;
    RequestHandler.post(`/StockMovement`, values).then((response) => {
      SetLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onSuccess = () => {
    form.resetFields();
    if (props.onSuccess) props.onSuccess();
  };

  const onFinishFailed = () => {
    SetLoading(false);
  };

  return (
    <div>
      <Form
        {...layout}
        form={form}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row>
          {isDesktopOrLaptop && (
            <>
              <Col span={20}>
                <Form.Item
                  label="Stok Adedi"
                  name="count"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Stok Adedi giriniz.",
                    },
                  ]}
                >
                  <CurrencyInput
                    className="ant-input"
                    style={{ width: "100%" }}
                    decimalSeparator=","
                    thousandSeparator="."
                    onChange={(value, name) => {
                      form.setFieldsValue({
                        count: name,
                      });
                    }}
                  />
                </Form.Item>

                <Form.Item
                  name="stockMovementType"
                  label="Stok Hareket Tipi"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Stok Hareket Tipi'ni seçiniz..",
                    },
                  ]}
                >
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                  >
                    <Select.Option key={1} value={1}>
                      {"Stok Girişi"}
                    </Select.Option>
                    <Select.Option key={2} value={2}>
                      {"Stok Çıkışı"}
                    </Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item label="Açıklama" name="description">
                  <TextArea rows={4} />
                </Form.Item>
              </Col>
              <Col span={4}></Col>
              <Col span={6}></Col>
              <Col span={6}></Col>
              <Col span={6}></Col>

              <Col span={6}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    onClick={() => SetLoading(true)}
                    loading={loading}
                  >
                    Ekle
                  </Button>
                </Form.Item>
              </Col>
            </>
          )}
          {isTabletOrMobileDevice && (
            <>
              <Col span={24}>
                <Form.Item
                  label="Stok Adedi"
                  name="count"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Stok Adedi giriniz.",
                    },
                  ]}
                >
                  <CurrencyInput
                    className="ant-input"
                    style={{ width: "100%" }}
                    decimalSeparator=","
                    thousandSeparator="."
                    onChange={(value, name) => {
                      form.setFieldsValue({
                        count: name,
                      });
                    }}
                  />
                </Form.Item>

                <Form.Item
                  name="stockMovementType"
                  label="Stok Hareket Tipi"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Stok Hareket Tipi'ni seçiniz..",
                    },
                  ]}
                >
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                  >
                    <Select.Option key={1} value={1}>
                      {"Stok Girişi"}
                    </Select.Option>
                    <Select.Option key={2} value={2}>
                      {"Stok Çıkışı"}
                    </Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item label="Açıklama" name="description">
                  <TextArea rows={4} />
                </Form.Item>
              </Col>

              <Col span={12}></Col>
              <Col span={6}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    onClick={() => SetLoading(true)}
                    loading={loading}
                  >
                    Ekle
                  </Button>
                </Form.Item>
              </Col>

              <Col span={6}></Col>
              <Col span={24}></Col>
              <Col span={24}></Col>
            </>
          )}
        </Row>
      </Form>
    </div>
  );
};
export default StockMovementAddForm;
